import { Input, Button } from "antd"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { getTranslated, getThemedImage } from "../../utils/CommonUtils"
import { SearchOutlined } from "@ant-design/icons"
import { PURPLE } from "../../styles/styleUtils";
import EmptyData from "./EmptyData"
import { setContentLoading } from "../../store/reducers/CommonReducer";

const UMCUsersList = (props) => {

    //local states--------------------------------------------
    const [searchValue, setSearchValue] = useState()
    const [options, setOptions] = useState() // list users
    const [hoveredItem, setHoveredItem] = useState()
    const [selectedValues, setSelectedValues] = useState([]) //checkbox selected users

    const [mode, setMode] = useState() // 3 modes - default | review | delete // new
    const [deleteCandidates, setDeleteCandidates] = useState([]); // users to be deleted
    const [unGroupedUsers, setUngroupedUsers] = useState([])
    const [selectedValuesForSearch, setSelectedValuesForSearch] = useState([])
    const [deleteModeSelectedValues, setDeleteModeSelectedValues] = useState([])

    const isAllSelected = deleteCandidates.length > 0 && deleteCandidates.length === selectedValues.length; //toggling
    //redux states--------------------------------------------
    const dict = useSelector(state => state.common.dict)
    const dispatch = useDispatch()

    const originalList = props.listItems?.map(item => //backup for searching
        typeof item === "string" ? JSON.parse(item) : item
    ) || [];

    const toggleSelectAll = () => {
        if (isAllSelected) {
            setDeleteCandidates([]); // Unselect all
        } else {
            setDeleteCandidates([...selectedValues]); // Select all
        }
    };

    useEffect(() => {
        if (Array.isArray(props.unGroupedUsers))//if (props.unGroupedUsers?.length > 0)
         {
            setUngroupedUsers(props.unGroupedUsers)
        }
    }, [props.unGroupedUsers])

    useEffect(() => {
        if (mode === 'review') {
            setSelectedValuesForSearch(selectedValues)
        } else if (mode === 'default' && props.isCreateMode === true) {
            setSelectedValuesForSearch(selectedValues)
        }
    }, [selectedValues])

    //useEffects-----------------------------------------------
    //-----------sets options as users from createright of response--
    useEffect(() => { //new
        if (props.isCreateMode === true)
            setMode("default")
        else if (props.isCreateMode === false)
            setMode("review")
    }, [])

    useEffect(() => {
        const normalizedList = props.listItems?.map(item =>
            typeof item === "string" ? JSON.parse(item) : item
        );
        setOptions(normalizedList);
    }, [props.listItems]);

    useEffect(() => {
        setSearchValue(props.value)
    }, [props.value])

    useEffect(() => {
        if (!props.isCreateMode)
            dispatch(setContentLoading(true))
        if (!props.isCreateMode && Array.isArray(unGroupedUsers))
            dispatch(setContentLoading(false))
    })

    useEffect(() => {
        if ( //props.unGroupedUsers?.length > 0
            Array.isArray(unGroupedUsers) && props.isCreateMode === false) {
            setMode("review")
            setOptions(props.unGroupedUsers)
            setSelectedValues(props.listItems)
        } else if (props.isCreateMode === true) { //new
            setMode("default")
        }
    }, [props.unGroupedUsers, props.isCreateMode])
    //local functions------------------------------------------
    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchValue(value)
        if (props.isCreateMode === true) {
            const filtered = originalList.filter(user =>
                (user.label || "").toLowerCase().includes(value.toLowerCase()) ||
                (user.id || "").toString().includes(value)
            );
            setOptions(filtered)
        } else {
            const filtered = unGroupedUsers.filter(user =>
                (user.label || "").toLowerCase().includes(value.toLowerCase()) ||
                (user.id || "").toString().includes(value)
            );
            setOptions(filtered)
        }
    }

    const handleDeleteModeSearch = (event) => {
        const value = event.target.value;
        setSearchValue(value)
        const filtered = selectedValuesForSearch.filter(user =>
            (user.label || "").toLowerCase().includes(value.toLowerCase()) ||
            (user.id || "").toString().includes(value)
        );
        setSelectedValues(filtered)
    }

    const toggleUserSelect = (user) => {
        const exists = selectedValues.find(u => u.id === user.id);
        const updated = exists ? selectedValues.filter(u => u.id !== user.id)
            : [...selectedValues, user];

        setSelectedValues(updated);
        props.handleListBoxSelect?.(updated);
    };

    //deletion 1
    const handleDeleteToggle = () => {
        setMode("delete");
        props.setModeInParent?.("delete");
        setDeleteCandidates([]); //start with none selected
    }

    //deletion 2 - deleteCandiadtes - have all selected values
    // when unchecked - it is added to updated const
    const handleDeleteCheckbox = (user) => {
        const isChecked = deleteCandidates.find(u => u.id === user.id);
        const updated = isChecked ? deleteCandidates.filter(u => u.id !== user.id)
            : [...deleteCandidates, user];

        setDeleteCandidates(updated);
    };

    // to remove deleted users from selectedValues array
    const finalizeDelete = () => {
        if (deleteCandidates.length === 0) return;

        // Remove all deleteCandidates from selectedValues
        const updated = deleteModeSelectedValues.filter(
            u => !deleteCandidates.some(d => d.id === u.id)
        );
        setSelectedValues(updated);
        props.handleListBoxSelect?.(updated);
        // Clear delete selection
        setDeleteCandidates([]);
        setMode("review");
        props.setModeInParent?.("review");
        setSearchValue("")
    };

    const finalizeAdd = () => {
        setMode("review");
        props.setModeInParent?.("review");
        setSearchValue("")
        // console.log(options)
        // console.log(selectedValues)
        // console.log(selectedValuesForSearch)
        // console.log(deleteCandidates)
        if(!props.isCreateMode)
            setOptions(unGroupedUsers)
    }
    useEffect(() => {
        if (mode === "review") {
            // console.log(selectedValues)
            // console.log(selectedValuesForSearch)
            setSelectedValuesForSearch(selectedValues)
        }
    }, [selectedValues, mode])

    useEffect(() => {
        if (mode === "delete") {
            // console.log(selectedValues)
            // console.log(selectedValuesForSearch)
            setDeleteModeSelectedValues(selectedValues)
        }
    }, [mode])

    const setAddMode = () => {
        setMode("default")
        props.setModeInParent?.("default");
    }

    // render user rows in list
    const renderUserRow = (user, isSelected, showCheckbox, onCheckboxClick, isOdd) => (
        <div
            key={user.id}
            className={`dd-item custom-sel-user-option  
                        ${isSelected && mode === "default" ? "active-sel" : ""}
                        ${isOdd ? "row-odd" : "row-even"}`}
            onClick={() => {
                if (mode === "default") toggleUserSelect(user)
                else if (mode === "delete") handleDeleteCheckbox(user);
            }}
            onMouseOver={() => setHoveredItem(user.id)}
            onMouseLeave={() => setHoveredItem("")}
        >
            <div className="custom-sel-user-span checkbox" onClick={e => {
                e.stopPropagation();
                if (mode === "delete") onCheckboxClick?.(user);
                if (mode === "default") toggleUserSelect(user);
            }}
            >
                {showCheckbox && (
                    <div className={`empty-checkbox ${isSelected ? "checked" : ""}`} />
                )}
            </div>
            {user?.imageIcon && (
                <div className="cmnt-icon-user">
                    <img
                        title={user.help}
                        src={getThemedImage(
                            hoveredItem === user.id || (mode === "default" && isSelected)
                                ? `light-${user.imageIcon}`
                                : `dark-${user.imageIcon}`
                        )}
                        alt="img"
                    />
                </div>
            )}
            <span className="custom-sel-span text-overflow-ellipsis">{user.label}</span>
            <span className="custom-sel-span text-overflow-ellipsis dir-number">{user.id}</span>
        </div>
    );

    // to render list based on mode
    const renderUserList = () => {
        if (mode === "review") {
            if (selectedValues.length === 0) return <EmptyData message={getTranslated(dict,"LABEL_NO_MEMBERS_SELECTED") }/>;
            return selectedValues.map((user, index) => renderUserRow(user, true, false, null, index % 2 !== 0));
        }

        if (mode === "delete") {
            if (selectedValues.length === 0) return <EmptyData message={getTranslated(dict,"LABEL_NO_MEMBERS_TO_DELETE")} />;
            return selectedValues.map((user, index) =>
                renderUserRow(user, !!deleteCandidates.find(u => u.id === user.id),
                    true,
                    handleDeleteCheckbox,
                    index % 2 !== 0
                )
            );
        }

        if (!Array.isArray(options)) return null;

        //Default mode     
        return options.map((rawUser, index) => {
            const user = typeof rawUser === "string" ? JSON.parse(rawUser) : rawUser;
            const isSelected = selectedValues.some(u => u.id === user.id);
            return renderUserRow(user, isSelected, true, null, index % 2 !== 0); //checkbox shown
        });

    };

    // rendering
    return (
        <div className={`list-dd-group dropdown-content ${props.className}`}>
            {mode === "default" ? (
                <Input
                    size="large"
                    value={searchValue}
                    onChange={handleSearch}
                    className="listbox-input"
                    placeholder={props.placeholder || getTranslated(dict, "LABEL_SEARCH")}
                    prefix={<SearchOutlined style={{ color: PURPLE }} />}
                />
            ) : (mode === "delete") ? (
                <Input
                    size="large"
                    placeholder={props.placeholder || getTranslated(dict, "LABEL_SEARCH")}
                    value={searchValue}
                    className="listbox-input"
                    prefix={<SearchOutlined style={{ color: PURPLE }} />}
                    onChange={handleDeleteModeSearch}
                />
            ) : (<></>
            )}
            <div className={`users-list-wrapper`}>
                {mode === "review" && selectedValues.length === 0 && (
                    <div
                        style={{
                            display: "flex",
                            padding: "10px",
                            borderBottom: "1px solid #eee",
                            background: "#fff",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            alignItems: "center"
                        }}
                    >
                        <Button
                            type="primary"
                            style={{
                                backgroundColor: '#6B42E1', // Purple
                                borderColor: '#6B42E1',
                                color: '#fff',
                                marginRight: 10
                            }}
                            onClick={() => {
                                setMode("default")
                                props.setModeInParent?.("default");
                            }}>{getTranslated(dict,"LABEL_ADD")}</Button>
                    </div>
                )}
                {mode === "review" && selectedValues.length > 0 && (
                    <div
                        style={{
                            display: "flex",
                            padding: "10px",
                            borderBottom: "1px solid #eee",
                            background: "#fff",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            alignItems: "center"
                        }}
                    >
                        <Button
                            type="primary"
                            style={{
                                backgroundColor: '#6B42E1', // Purple
                                borderColor: '#6B42E1',
                                color: '#fff',
                                marginRight: 10
                            }}
                            onClick={setAddMode}   // adding handler
                                >{getTranslated(dict,"LABEL_ADD")}</Button>
                        <Button danger
                            style={{
                                backgroundColor: '#D91B1B', // Red
                                borderColor: '#D91B1B',
                                color: '#fff'
                            }}
                            onClick={handleDeleteToggle}>{getTranslated(dict,"LABEL_DELETE")}</Button>
                    </div>
                )}

                <div className={`dd-search-items-groups ${mode === "delete" ? "with-footer" : ""}`}>
                    {renderUserList()}
                </div>

                {(mode === "default" || mode === "delete") && props.showAddButton && (
                    <div className="add-members-btn">
                        {mode === "delete" ? (
                            deleteCandidates.length === 0 && props.isCreateMode ? (
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setMode("default");
                                        props.setModeInParent?.("default");
                                    }}
                                >
                                    {getTranslated(dict,"LABEL_BACK")}
                                </Button>
                            ) : (

                                <>
                                    <Button
                                        type="primary"
                                        style={{
                                            backgroundColor: '#6B42E1', // Purple
                                            borderColor: '#6B42E1',
                                            color: '#fff',
                                            marginRight: 10
                                        }}
                                        onClick={toggleSelectAll}>
                                        {getTranslated(dict, (isAllSelected ? "LABEL_UNSELECT_ALL" : "LABEL_SELECT_ALL"))}
                                    </Button>

                                    <Button danger
                                        style={{
                                            backgroundColor: '#D91B1B', // Red
                                            borderColor: '#D91B1B',
                                            color: '#fff'
                                        }}
                                        type="primary"
                                        disabled={deleteCandidates.length === 0}
                                        onClick={finalizeDelete}
                                    >
                                        {getTranslated(dict,"LABEL_DELETE")} ({deleteCandidates.length} {deleteCandidates.length === 0 ? '': 
                                                getTranslated(dict, deleteCandidates.length > 1 ?'LABEL_MEMBERS':'LABEL_MEMBER')})
                                    </Button>
                                </>)
                        ) : (
                            selectedValues.length > 0 && (
                                <Button
                                    type="primary"
                                    onClick={finalizeAdd}
                                >
                                    {getTranslated(dict,"LABEL_ADD")} ({selectedValues.length} {selectedValues.length === 0 ? '': 
                                                getTranslated(dict, selectedValues.length > 1 ? 'LABEL_MEMBERS':'LABEL_MEMBER')})
                                </Button>
                            )
                        )}
                    </div>
                )}

            </div>
        </div>
    );
}

export default UMCUsersList
